import { cardSetConstants } from "../_constants";

const initialState = {
  cardSets: null,
  currentCardSet: null,
  allCardSetsLoading: false,
  allCardSetsError: null,
  addCardSetLoading: false,
  addCardSetError: null,
  viewCardSetLoading: false,
  viewCardSetError: null,
  editCardSetLoading: false,
  editCardSetError: null,
};

const {
  GET_ALL_CARDSETS_START,
  GET_ALL_CARDSETS_SUCCESS,
  GET_ALL_CARDSETS_FAILED,
  ADD_CARDSET_START,
  ADD_CARDSET_END,
  ADD_CARDSET_FAILED,
  VIEW_CARDSET_START,
  VIEW_CARDSET_SUCCESS,
  VIEW_CARDSET_FAILED,
  EDIT_CARDSET_START,
  EDIT_CARDSET_END,
  EDIT_CARDSET_SUCCESS,
  EDIT_CARDSET_FAILED,
} = cardSetConstants;

export default function cardSetReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_CARDSETS_START:
      return {
        ...state,
        allCardSetsLoading: true,
      };
    case GET_ALL_CARDSETS_SUCCESS:
      return {
        ...state,
        allCardSetsLoading: false,
        cardSets: action.payload,
      };
    case GET_ALL_CARDSETS_FAILED:
      return {
        ...state,
        allCardSetsLoading: false,
        allCardSetsError: action.payload,
      };
    case ADD_CARDSET_START:
      return {
        ...state,
        addCardSetLoading: true,
      };
    case ADD_CARDSET_END:
      return {
        ...state,
        addCardSetLoading: false,
      };
    case ADD_CARDSET_FAILED:
      return {
        ...state,
        addCardSetLoading: false,
        addCardSetError: action.payload,
      };
    case VIEW_CARDSET_START:
      return {
        ...state,
        viewCardSetLoading: true,
      };
    case VIEW_CARDSET_SUCCESS:
      return {
        ...state,
        viewCardSetLoading: false,
        currentCardSet: action.payload,
      };
    case VIEW_CARDSET_FAILED:
      return {
        ...state,
        viewCardSetLoading: false,
        viewCardSetError: action.payload,
      };
    case EDIT_CARDSET_START:
      return {
        ...state,
        editCardSetLoading: true,
      };
    case EDIT_CARDSET_END:
      return {
        ...state,
        editCardSetLoading: false,
      };
    case EDIT_CARDSET_SUCCESS:
      return {
        ...state,
        editCardSetLoading: false,
        currentCardSet: action.payload,
      };
    case EDIT_CARDSET_FAILED:
      return {
        ...state,
        editCardSetLoading: false,
        editCardSetError: action.payload,
      };
    default:
      return state;
  }
}
